import React, { FC } from 'react'

type IconProps = {
  className?: string
}

export const OutlineIcon: FC<IconProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'40'}
      viewBox={'0 0 40 40'}
      width={'40'}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <mask fill={'white'} id={'path-1-inside-1_7110_20952'}>
        <path
          d={
            'M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z'
          }
        />
      </mask>
      <path
        d={
          'M20 40V38.5C9.78273 38.5 1.5 30.2173 1.5 20H0H-1.5C-1.5 31.8741 8.12588 41.5 20 41.5V40ZM40 20H38.5C38.5 30.2173 30.2173 38.5 20 38.5V40V41.5C31.8741 41.5 41.5 31.8741 41.5 20H40ZM20 0V1.5C30.2173 1.5 38.5 9.78273 38.5 20H40H41.5C41.5 8.12588 31.8741 -1.5 20 -1.5V0ZM20 0V-1.5C8.12588 -1.5 -1.5 8.12588 -1.5 20H0H1.5C1.5 9.78273 9.78273 1.5 20 1.5V0Z'
        }
        fill={'currentColor'}
        mask={'url(#path-1-inside-1_7110_20952)'}
      />
    </svg>
  )
}
